import {createSelector, Selector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {REGIONS_SLICE} from './constants';
import {IRegionDto, IRegionsState} from './types';

const rootSelector: Selector<TAppState, IRegionsState> = (state: TAppState) => state[REGIONS_SLICE];

export const selectRegions: Selector<TAppState, IRegionDto[] | undefined> = createSelector(
    rootSelector,
    ({data}: IRegionsState) => data,
);
